
const digest = '377d110e944949904e0a5adcba6f87d497e0a087bd9e558b0f1fd474987a998a';
const classes = {"wrapper":"_wrapper_z4l5m_1","overLimit":"_overLimit_z4l5m_12"};
const css = `._wrapper_z4l5m_1 {
  font-family: Poppins, sans-serif;
  display: flex;
  align-items: flex-end;
  font-size: 14px;
  flex: 1;
  flex-direction: column;
  margin: 7px 0;
  color: #909090;
}

._overLimit_z4l5m_12 {
  color: #d81616;
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  